import { render, staticRenderFns } from "./LocalizedDatePicker.vue?vue&type=template&id=d6609a44"
import script from "./LocalizedDatePicker.vue?vue&type=script&lang=js"
export * from "./LocalizedDatePicker.vue?vue&type=script&lang=js"
import style0 from "./LocalizedDatePicker.vue?vue&type=style&index=0&id=d6609a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports